export const USER_ROLES = {
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
  PILOT: 'pilot',
  MASTER: 'master',
}
